export default function MemberSearchFieldCtrl($scope, $state, $stateParams) {

  // $scope.query = {term: $stateParams.query};


  $scope.search = function (term) {
    $state.go('member.account.search', {query: term});
  }
}
